import f from "./index33.js";
import { resolveComponent as l, openBlock as n, createElementBlock as t, normalizeClass as r, createElementVNode as o, createVNode as d, createCommentVNode as i, createBlock as u, Transition as p, withCtx as v, withDirectives as M, renderSlot as g, vShow as b } from "vue";
import "./index34.js";
import w from "../../../../_virtual/index.js";
const k = { class: "mobile-header-hat" }, H = { class: "mobile-left" }, _ = { class: "mobile-right" }, C = {
  key: 0,
  class: "help-container"
}, S = {
  key: 0,
  class: "menu-content"
};
function $(e, s, y, B, E, L) {
  const c = l("HeaderLogo"), h = l("SearchModalMobile"), m = l("MobileMenu");
  return n(), t("div", {
    class: r(["mobile-header-container", e.bannerStyle.toLowerCase()])
  }, [
    o("div", {
      class: r(["mobile-header", [e.showMenu ? "mobile-header-opened-menu" : ""]])
    }, [
      o("div", k, [
        o("div", H, [
          d(c, { config: e.config }, null, 8, ["config"])
        ]),
        o("div", _, [
          e.config.showHelpMenu !== !1 ? (n(), t("div", C, [
            o("a", {
              href: "/help/",
              class: "help-link",
              onClick: s[0] || (s[0] = (...a) => e.navigationEventBus.navigateToHref && e.navigationEventBus.navigateToHref(...a))
            }, " Help ")
          ])) : i("", !0),
          e.showSearch ? (n(), u(h, {
            key: 1,
            class: "mobile-search",
            config: e.config
          }, null, 8, ["config"])) : i("", !0),
          e.showHamburgerMenu ? (n(), u(m, {
            key: 2,
            class: "mobile-right-menu",
            onClick: s[1] || (s[1] = (a) => e.setShowMenu(!e.showMenu)),
            showMenu: e.showMenu
          }, null, 8, ["showMenu"])) : i("", !0)
        ])
      ]),
      e.showHamburgerMenu ? (n(), t("div", S, [
        d(p, { name: "slide" }, {
          default: v(() => [
            M(o("div", null, [
              g(e.$slots, "default", {}, void 0, !0)
            ], 512), [
              [b, e.showMenu]
            ])
          ]),
          _: 3
        })
      ])) : i("", !0)
    ], 2)
  ], 2);
}
const D = /* @__PURE__ */ w(f, [["render", $], ["__scopeId", "data-v-e80f2f2a"]]);
export {
  D as default
};
//# sourceMappingURL=index17.js.map
